var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurfing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m35.545 26.61.284 8.313.002.046-5.342 6.706c-2.432 3.052-5.68 5.35-9.368 6.627-3.729 1.291-7.67 1.855-11.612 1.66l-6.437-.316.772-3.379c.767-3.359 2.58-6.388 5.175-8.653 2.661-2.322 5.457-4.484 8.374-6.474l3.888-2.654-2.543 9.658-5.125 1.523-1.891.562.44 1.92.598 2.608.432 1.886 1.917-.275 9.041-1.297 1.25-.18.43-1.184 4.428-12.228 5.287-4.869Zm-2.181-6.369.778 1.79.927 2.16-6.613 6.093-4.605 12.708-9.04 1.296-.598-2.607 6.26-1.86 3.46-13.144 9.43-6.436Zm6.213-4.24 1.895 8.724-.068 3.25-3.555 4.462-.264-7.707.016-.014-.594-1.368-.966-2.225-.898-2.096 4.434-3.026Zm6.023 6.706-2.035 2.555.01-.493.006-.247-.053-.242-.242-1.115 2.314-.458Zm-3.305-8.56 4.587 5.248-.218.96-3.877.769-1.315-5.997-.34-.187 1.163-.793Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m33.334 3.654 6.562 1.65 4.338 3.594 3.359 7.376-.929 4.08-3.877.77-1.315-5.997-2.448-1.348.443 1.714 2.005 9.232-.19 9.02-.275.07-3.085.77-.337-9.86-3.887-9.066-1.942-3.07 2.75-5.355-1.172-3.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "33.334 3.654 39.896 5.305 44.234 8.898 47.593 16.274 46.664 20.355 42.787 21.124 43.718 14.147 39.569 8.483 34.506 7.234",
    opacity: 0.299
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5C1A7",
    points: "26.898 2.485 30.867 2.802 32.247 7.04 30.131 11.168 25.186 9.703 23.457 4.776"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "24.348 .793 28.328 0 30.867 2.802 31.55 4.776 29.529 4.148 27.701 5.461 25.204 5.234 24.334 7.268 23.457 4.776"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "24.106 26.018 32.806 18.956 35.077 24.184 28.456 30.284 23.851 42.992 14.81 44.288 14.213 41.681 20.472 39.821"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "23.008 17.893 29.769 14.147 31.756 16.789 23.342 23.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "16.479 1.141 21.799 2.215 21.227 4.765 22.122 7.255 16.11 4.838 5.761 4.798 5.761 2.215"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5C1A7",
    points: "37.999 36.01 41.348 35.173 41.348 39.058 37.999 39.058"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5C1A7",
    points: "0 3.514 3.694 2.417 3.694 4.842 0 4.842"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfing);
export default __webpack_public_path__ + "static/media/surfing.3647d6b4080be0dd55981744d53c90c7.svg";
export { ForwardRef as ReactComponent };